module.exports = __webpack_public_path__ + "img/hero-bg.672f2f0c.webp";